var indentation_default = {
  "indentZero": "tTvP1",
  "indentOne": "HHDI3",
  "indentTwo": "_-8yyN",
  "indentThree": "bkjey",
  "indentFour": "vI5NL",
  "indentFive": "hcEdY",
  "indentSix": "VPscH"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
